module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/permission-420b4af99d86af07ec91a8381f21be75.svg";